import {TreeNodePage, TreeNodeCore} from '@/stores/apolloPlatform/cores/portalNavigation';
import {RouteRecordRaw} from 'vue-router';

const pageRouteRecursive = (nodes: TreeNodePage[]) => {
  const records: RouteRecordRaw[] = [];
  for (const node of nodes) {
    if (node.meta.type !== 'cms.CategoryIndexPage') {
      const path = node.meta.url_path.slice(node.meta.url_path.indexOf('/', 1));
      const pageRoute: RouteRecordRaw = {
        name: `page-${node.meta.id}`,
        path,
        component: () => import('@/components/cores/PageView.vue'),
        props: () => ({meta: node.meta}),
        meta: {node},
        children: [],
      };
      if (
        node.meta.type === 'cms.DynamicPage' &&
        node.meta.url_path.match('portfolio|portefeuille') !== null
      ) {
        // N.B. nested <vue-router> in ProductCatalogueApp.vue & similar is broken.
        pageRoute.children.push({
          name: `page-${node.meta.id}-form`,
          path: 'update/:id?',
          alias: 'create/:id?',
          component: () => import('@/components/cores/PageView.vue'),
          props: () => ({meta: node.meta}),
          meta: {node, subpage: 'ProductCatalogueForm'},
        });
      }
      records.push(pageRoute);
    } else if (node.children && node.children.length > 0) {
      records.push(...pageRouteRecursive(node.children)); // Recursively add children
    }
  }
  return records;
};

export const createCoreRoute = (node: TreeNodeCore): RouteRecordRaw[] => {
  let core: RouteRecordRaw | undefined = undefined;
  if (node.meta.type === 'cms.DashboardPage') {
    if (node.meta.slug === 'home') {
      // Home is served by the static /home route (available before nav loads).
      return pageRouteRecursive(node.children);
    }
    core = {
      name: `core-${node.meta.id}`,
      path: node.meta.slug,
      component: () => import('@/components/cores/DashboardView/DashboardView.vue'),
      props: () => ({node}),
      meta: {node},
    };
  } else if (node.meta.type === 'cms.NewsIndexPage') {
    // NewsIndexPage is a core node but renders as a page
    core = {
      name: `core-${node.meta.id}`,
      path: node.meta.slug,
      component: () => import('@/components/cores/PageView.vue'),
      props: () => ({meta: node.meta}),
      meta: {node},
    };
  } else if (node.meta.type !== 'cms.CoreIndexPage') {
    core = {
      name: `page-${node.meta.id}`,
      path: node.meta.slug,
      component: () => import('@/components/cores/PageView.vue'),
      props: () => ({meta: node.meta}),
      meta: {node},
    };
  }
  const children = pageRouteRecursive(node.children);
  return core !== undefined ? [core, ...children] : children;
};
